// extracted by mini-css-extract-plugin
export var softwareSupport = "SoftwareSupport-module--softwareSupport--6k2z7";
export var inner = "SoftwareSupport-module--inner--AL48J";
export var linkSupport = "SoftwareSupport-module--linkSupport--WGn8R";